import { getColors, ColorProps } from '@osmosis/shared/styles';

export function useColors(scheme: 'light' | 'dark' = 'light'): ColorProps {
  return getColors(scheme);
}
